// src/App.tsx
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider } from './contexts/ThemeContext';
import ScrollToTop from './components/ui/ScrollToTop';
import PageLoader from './components/ui/PageLoader';

// Import pages normally (no lazy loading) for instant navigation
import HomePage from './pages/HomePage';
import Program from './pages/Program';
import Desa from './pages/Desa';
import TimKKN from './pages/Kkn';
import Dokumentasi from './pages/Dokumentasi';

function App() {
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  // Handle initial app loading ONLY
  useEffect(() => {
    const initializeApp = async () => {
      // Simulate app initialization (fonts, theme, etc.)
      // You can add real initialization logic here like:
      // - Loading fonts
      // - Setting up theme
      // - Checking authentication
      // - Loading critical resources
      await new Promise(resolve => setTimeout(resolve, 2000));
      setIsInitialLoading(false);
    };

    initializeApp();
  }, []); // Empty dependency array - runs only once

  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
          {/* Initial App Loader - ONLY ONCE */}
          <PageLoader 
            isLoading={isInitialLoading} 
            onComplete={() => setIsInitialLoading(false)}
          />

          {/* Main App Content */}
          {!isInitialLoading && (
            <>
              <Routes>
                {/* Main Routes - No Suspense needed */}
                <Route path="/" element={<HomePage />} />
                <Route path="/program" element={<Program />} />
                <Route path="/desa" element={<Desa />} />
                <Route path="/kkn" element={<TimKKN />} />
                <Route path="/dokumentasi" element={<Dokumentasi />} />
                
                {/* Catch-all route for 404 - redirect to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              
              {/* Global Components */}
              <ScrollToTop />
              
              {/* Vercel Analytics - tracks page views automatically */}
              <Analytics />
            </>
          )}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;